module.exports = __webpack_public_path__ + "img/335.3a7aa540.png";